 /**
  * Role Constants
  * 
  * Defines all RBAC roles used in the system.
  * These match database enums and edge function checks.
  */
 
 // Internal platform admin roles
 export const ADMIN_ROLES = {
   ADMIN: 'admin',
   SUPER_ADMIN: 'super_admin', // reserved for future use
 } as const;
 
 // Dealer organization roles (matches dealer_memberships view)
 export const DEALER_ROLES = {
   ADMIN: 'admin',  // dealer account owner
   SALES: 'sales',  // salesperson
 } as const;
 
 // User persona types (for routing/UI decisions)
 export const USER_PERSONAS = {
   BUYER: 'buyer',
   SUBSCRIBER: 'subscriber', // buyer with active entitlement
   DEALER_ADMIN: 'dealer_admin',
   SALESPERSON: 'salesperson',
   ADMIN: 'admin',
 } as const;
 
 // Type exports
 export type AdminRole = typeof ADMIN_ROLES[keyof typeof ADMIN_ROLES];
 export type DealerRole = typeof DEALER_ROLES[keyof typeof DEALER_ROLES];
 export type UserPersona = typeof USER_PERSONAS[keyof typeof USER_PERSONAS];